import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useApiError } from '@/modules/common/hooks/use-api-error';
import { invalidateInvoiceQueries } from '@/modules/common/utils/query-invalidation';

import { updateInvoice } from '../api';

/** Updates an invoice and clears all invoice views that can contain its stale snapshot. */
export const useUpdateInvoice = () => {
  const queryClient = useQueryClient();
  const { displayToastErrorFromApiWithFallback } = useApiError();

  return useMutation({
    mutationFn: updateInvoice,
    onSuccess: async () => invalidateInvoiceQueries(queryClient),
    onError: error =>
      displayToastErrorFromApiWithFallback(error, 'authenticated.invoices:toasts.updateError'),
  });
};
